module.exports = __webpack_public_path__ + "r-v3/img/set_join.5b818351.svg";